// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KAnp","type":"styles_type__YlUJv","choices":"styles_choices__2JewH"};